<template>
  <v-app-bar absolute color="primary" dark flat height="85">
    <v-btn text>
      <img src="@/assets/school360online.png" alt="School 360 Online Logo" width="100" />
      <v-toolbar-title class="font-weight-light hidden-xs-only" v-text="title" />
    </v-btn>

    <v-spacer />

    <v-btn
      v-for="(item, i) in appBarMenuItems"
      :key="i"
      :to="item.to"
      min-height="48"
      min-width="40"
      text
    >
      <v-icon :left="$vuetify.breakpoint.mdAndUp" size="20" v-text="item.icon" />

      <span class="hidden-sm-and-down" v-text="item.text" />
    </v-btn>

    <v-menu bottom left min-width="200" offset-y origin="top right" transition="scale-transition">
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
          {{displayName}}
        </v-btn>
      </template>

      <v-list :tile="false" flat nav>
        <template v-for="(p, i) in profileMenuItems">
          <v-divider v-if="p.type === 'divider'" :key="`divider-${i}`" class="mb-2 mt-2" />

          <v-list-item v-else-if="p.type === 'signout-action'" :key="`item-${i}`" @click="signOut">
            <v-list-item-title v-text="p.title" />
          </v-list-item>

          <app-bar-item v-else :key="`item-${i}`" :to="p.to">
            <v-list-item-title v-text="p.title" />
          </app-bar-item>
        </template>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
// Components
import { VHover, VListItem } from "vuetify/lib";
import { mapGetters } from "vuex";

export default {
  name: "UserPagesCoreAppBar",

  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs
                  }
                },
                this.$slots.default
              );
            }
          }
        });
      }
    }
  },

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    title: "School 360 Online - SIMS"
  }),

  computed: {
    ...mapGetters("userAccountService", {
      appBarMenuItems: "appBarMenuItems",
      profileMenuItems: "profileMenuItems"
    }),
    ...mapGetters("authenticationService", {
      displayName: "displayName"
    })
  },
  methods: {
    signOut() {
      this.$store
        .dispatch("authenticationService/signOut")
        .then(() => {
          this.$router.push("/pages/login");
        })
        .catch(error => {});
    }
  },
  created() {}
};
</script>
